import { DICT_KEY, getDictNameByCode, getModel, setModel } from "../../../utils/constants";
import ModelUtils from "../../../utils/ModelUtils";
import dinoutService from "./dinoutService";
import moment from "moment";
// import {v4 as uuidv4} from "uuid"

const dinoutModel = {
    state: {
        //查询参数
        searchParam: {},
        //配件交易频次查询列表
        partDealList: [],
        //配件交易频次->选中keys
        partDealListSelectedRowKeys: [],
        //配件交易频次分页
        searcnPage: {
            total: 0,
            pageNum: 1,
            pageSize: 15
        },
        //销售订单统计信息
        documentStatistic: {
            storageQuantityTotal: 0,
            deliveryQuantityTotal: 0,
            differenceTotal: 0,
        },
    },

    reducers: {
        setSearchParam(state, payload) {
            state.searchParam = { ...state.searchParam, ...payload };
            // if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        resetSearchParam(state, ) {
            state.searchParam = {};
            // if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setPartDealListSelectedRowKeys(state, payload) {
            state.partDealListSelectedRowKeys = payload;
            // setModel(MODEL_KEY, {...state});
        },
        setDocumentStatistic(state, payload) {
            state.documentStatistic = payload;
            // if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setPartDealListList(state, payload){
            state.partDealList = payload;
        },
        setSearcnPage(state, payload) {
            state.searcnPage = payload;
            // if (cacheAble) setModel(MODEL_KEY, {...state});
        },
    },

    effects: () => ({
        //加载进销存列表
        async loadListDetail({ showMsg = true, duration = 5, data }) {
            const funName = "加载进销存数据";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            // console.log("加载成功", data)
            const func = async () => {
                let retData = await dinoutService.findPage(data);
                const {list, statistics,  ...page} = retData;
                const mappedList = list.map(el => {
                    let categoryName = el.category ? getDictNameByCode(DICT_KEY.CM_DICT.MATERIAL_SORT, el.category, true) : ""
                    return {
                        key: el.id,
                        ...el,
                        categoryName,
                        orgName: el.orgId ? getDictNameByCode(DICT_KEY.CM_DICT.ORG, el.orgId, true) : "",
                        warehouseName: el.warehouseId ? getDictNameByCode(DICT_KEY.CM_DICT.WAREHOUSE, el.warehouseId) : "",
                        orderStatusName: el.orderStatus ? getDictNameByCode(DICT_KEY.CM_DICT.STOCK_CHECK_STATUS, el.orderStatus) : "",
                    }
                })
                // list.forEach(el => el.key = el.id);
                this.setPartDealListList(mappedList);
                this.setSearcnPage(page);
                this.setDocumentStatistic(statistics);
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);

        },
        //导出配件交易列表
        async exportPartDealList({ showMsg = true, duration = 5, data }) {
            const funName = "导出盘点数据";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            // console.log("导出成功")
            // const func = async () => {
            //     let retData = await dinoutService.exportCheckList(data);
            //     return retData;
            // };
            // return await ModelUtils.execute({
            //     funName, sucMsg, failMsg, showMsg, duration
            // }, func);
        },
    })
};

export default dinoutModel;